export default __webpack_public_path__ + "static/contact-phone@2x-83fa928f8b7c7a3065e294731f824a43.png";